import * as THREE from 'three';
import { CityState } from '../simulation/types';
import { AssetManager } from './AssetManager';

export class RoadRenderer {
  private scene: THREE.Scene;
  private roadMeshes: Map<string, THREE.Object3D> = new Map();

  constructor(scene: THREE.Scene) {
    this.scene = scene;
  }

  public render(state: CityState) {
    const roads = state.roads;
    const activeKeys = new Set(Object.keys(roads));

    const assetMgr = AssetManager.getInstance();
    const halfWidth = state.width / 2;
    const halfHeight = state.height / 2;

    for (const key of activeKeys) {
      const road = roads[key];
      const worldX = road.x - halfWidth + 0.5;
      const worldZ = road.y - halfHeight + 0.5;

      let mesh = this.roadMeshes.get(key);
      if (!mesh) {
        mesh = assetMgr.getRoadMesh(road.autoTilingId);
        mesh.position.set(worldX, 0, worldZ);
        this.scene.add(mesh);
        this.roadMeshes.set(key, mesh);
      } else {
        // If autoTilingId changed, recreate the mesh to match connections
        // Since we are caching, we can just replace the mesh if connections change!
        // To be safe, let's verify if the auto-tiling matches. Since recreating is fast and cheap, we can do it!
        this.scene.remove(mesh);
        mesh = assetMgr.getRoadMesh(road.autoTilingId);
        mesh.position.set(worldX, 0, worldZ);
        this.scene.add(mesh);
        this.roadMeshes.set(key, mesh);
      }
    }

    // Demolish roads that are no longer active
    for (const key of Array.from(this.roadMeshes.keys())) {
      if (!activeKeys.has(key)) {
        const mesh = this.roadMeshes.get(key);
        if (mesh) {
          this.scene.remove(mesh);
        }
        this.roadMeshes.delete(key);
      }
    }
  }

  public clear() {
    this.roadMeshes.forEach((mesh) => this.scene.remove(mesh));
    this.roadMeshes.clear();
  }
}
